import React, { useState, useEffect } from 'react';
import { Box, Button, useTheme, useMediaQuery } from '@mui/material';
import { useTranslation } from '../../hooks/useTranslation';

const ActionButtons = (props) => {
	const { t } = useTranslation();
	const theme = useTheme();
	const isMobileOrTablet = useMediaQuery(theme.breakpoints.down('lg'));
	const isDark =
		props.customDetails?.darkTheme === true || theme.palette.mode === 'dark';
	const [footerHeight, setFooterHeight] = useState(70);

	useEffect(() => {
		const calculateFooterHeight = () => {
			const footer = document.querySelector('.MuiBox-root footer, footer');
			if (footer) {
				const height = footer.offsetHeight;
				setFooterHeight(height);
			}
		};

		calculateFooterHeight();
		window.addEventListener('resize', calculateFooterHeight);

		return () => {
			window.removeEventListener('resize', calculateFooterHeight);
		};
	}, []);

	return (
		<Box
			sx={{
				fontFamily: props.customDetails?.fontFamily,
				position: 'fixed',
				bottom: '5px',
				left: 0,
				right: 0,
				zIndex: 999,
				backgroundColor: isDark
					? '#161616'
					: props.customDetails?.secondaryColor || '#fff',
				borderTop: `1px solid ${isDark ? '#2D2D2D' : '#E0E0E0'}`,
				paddingTop: isMobileOrTablet ? '25px' : '20px',
				marginTop: isMobileOrTablet && '5px',
				paddingBottom: `${footerHeight - 5}px`,
				display: 'flex',
				alignItems: 'center',
			}}
		>
			<Box
				sx={{
					display: 'flex',
					flexDirection: isMobileOrTablet ? 'column' : 'row-reverse',
					gap: '12px',
					justifyContent: 'center',
					width: isMobileOrTablet ? '90%' : '45%',
					margin: '0 auto',
				}}
			>
				<Button
					variant="contained"
					sx={{
						flex: 1,
						backgroundColor:
							props.customDetails?.primaryColor || theme.palette.primary.main,
						color: '#fff',
						textTransform: 'none',
						fontSize: '0.875rem',
						fontWeight: 500,
						fontFamily: props.customDetails?.fontFamily,
						padding: '12px 24px',
						borderRadius: '8px',
						boxShadow: 'none',
						'&:hover': {
							backgroundColor:
								props.customDetails?.primaryColor || theme.palette.primary.dark,
							boxShadow: 'none',
						},
					}}
					onClick={props.onApprove}
				>
					{t('consentRenewal.buttons.yesRenew')}
				</Button>
				<Button
					variant="outlined"
					sx={{
						flex: 1,
						borderColor:
							props.customDetails?.primaryColor || theme.palette.primary.main,
						color:
							props.customDetails?.primaryColor || theme.palette.primary.main,
						textTransform: 'none',
						fontSize: '0.875rem',
						fontWeight: 500,
						fontFamily: props.customDetails?.fontFamily,
						padding: '12px 24px',
						borderRadius: '8px',
						backgroundColor: isDark
							? 'transparent'
							: props.customDetails?.secondaryColor || '#fff',
						'&:hover': {
							borderColor:
								props.customDetails?.primaryColor || theme.palette.primary.main,
							backgroundColor: isDark ? '#2D2D2D' : 'rgba(0,0,0,0.04)',
						},
					}}
					onClick={props.onCancel}
				>
					{t('consentRenewal.buttons.noDontRenew')}
				</Button>
			</Box>
		</Box>
	);
};

export default ActionButtons;
